import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import DropdownMenu from '@cobliteam/ui/components/DropdownMenu';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Icon from '@cobliteam/ui/icons';
import type { ReactNode } from 'react';

export interface DataTableExportProps {
  children: ReactNode;
  exporting?: boolean;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const DataTableExport = ({ children, exporting = false, defaultOpen = false, open, onOpenChange }: DataTableExportProps) => {
  const { t } = useTranslation('ui-business');

  return (
    <DropdownMenu defaultOpen={defaultOpen} open={open} onOpenChange={onOpenChange}>
      <Tooltip content={t('data_table.export')} asChild>
        <DropdownMenu.Trigger asChild>
          <Button variant='outlined' color='primary' size='sm' loading={exporting} icon={<Icon name='download' />} />
        </DropdownMenu.Trigger>
      </Tooltip>
      <DropdownMenu.Content align='start'>{children}</DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default DataTableExport;
